import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.landingPage.index'),
        name: 'landingPage.index',
        component: () =>
            import(
                /* webpackChunkName: "landing-pages" */ '@/views/landing-pages/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.landingPage.breadcrumb.index'),
                    to: { name: 'landingPage.index' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.landingPage.create'),
        name: 'landingPage.create',
        component: () =>
            import(
                /* webpackChunkName: "landing-pages" */ '@/views/landing-pages/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.landingPage.breadcrumb.index'),
                    to: { name: 'landingPage.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: { name: 'landingPage.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.landingPage.edit') + '/:id',
        name: 'landingPage.edit',
        component: () =>
            import(
                /* webpackChunkName: "landing-pages" */ '@/views/landing-pages/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.landingPage.breadcrumb.index'),
                    to: { name: 'landingPage.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.edit'),
                    to: { name: 'landingPage.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
